<template>
  <div class ="col-12">
    <div class="row d-flex justify-content-center">
      <vue-headful :title="`${user.full_name} • ${$store.state.settings.settings.site_name}`" />
      <div class="col-lg-8 col-md-12">
        <user-edit-form
          :user="user"
          :user-roles="userRoles"
          :user-added="userAdded"
          :password-min-length="passwordMinLength"
          @updateUser="$emit('updateUser', $event)" />
      </div>
      <div class="col-lg-4 col-md-12">
        <user-profile-card :user="user" />
      </div>
    </div>
  </div>
</template>
<script>
import UserProfileCard from 'src/components/UserProfileCard.vue';
import UserEditForm from './UserEditForm.vue';

export default {
  name: 'UserDetail',
  components: {
    UserEditForm,
    UserProfileCard,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    userRoles: {
      type: Array,
      required: true,
    },
    passwordMinLength: {
      type: Number,
      required: true,
    },
    userAdded: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
